<template>
  <div class="text-center padding">
    <div v-if="!submited">
      <h2
        v-if="slide.title"
        class="mt-0 text-left slide-title-style"
        v-html="dataValue"
      />
      <p v-if="slide.titleDesc" class="custom-mb-3 text-left slide-title-style title-desc">
        {{ slide.titleDesc }}
      </p>
      <div
        v-if="!slide.title && !slide.titleDesc"
        class="text-center no-data"
      >
        {{ $t("blankSlide") }}
      </div>
      <div
        v-if="slide.audioLink && slide.audioPlayOnAudience && slide.id"
        class="audio-control-slide"
      >
        <AudioControl />
      </div>

      <ProgressBarTimer />

      <div v-if="slide.image" class="slide-img-wrapper">
        <Loading v-if="isLoading" />
        <img
          v-else
          ref="slide-imgg"
          :src="slide.image.large"
          alt
          class="slide-img"
          @load="_imgLoaded"
        >
      </div>
      <form @submit.prevent="submit">
        <div class="list-input">
          <div v-for="(item, index) in items" :key="index">
            <div class="item-input" :class="{error: (25 - item.title.length) < 0 || item.error}">
              <input
                v-model="item.title"
                type="text"
                :placeholder="$t('enterWordPlaceholder')"
                maxlength="25"
                class="item-input-text"
                @input="validateInput(item)"
              >
              <div class="item-input-limit">
                {{ 25 - item.title.length }}
              </div>
            </div>

            <div
              v-if="item.error"
              class="text-danger"
              :class="{'white-text': isTextColourLight}"
            >
              {{ item.error }}
            </div>
          </div>
        </div>

        <div
          v-if="slide.openEndedMultipleOption && !isFirstTimeSubmit"
          class="label"
        >
          {{ $t("submitMultipleTimes") }}
        </div>

        <div v-if="isFirstTimeSubmit && !submited" class="submited">
          {{ $t("open-endedInstructionSubmission") }}
        </div>

        <aha-antd-button
          variant="primary-alt"
          block
          size="lg"
          class="custom-mb-3"
          type="submit"
          :disabled="slide.stopSubmission && !submiting"
          :submitting="submiting"
          isLoadingInline
        >
          <template v-if="!slide.stopSubmission">
            <span>
              {{ $t("submit") }}
              <CountDownTimer class="ml-1" />
            </span>
          </template>

          <template v-if="slide.stopSubmission">
            <i class="fa fa-lock" />
            <span class="ml-2">{{ $t("submissionClosedButton") }}</span>
          </template>
        </aha-antd-button>

        <aha-antd-button
          v-show="isShowNextSlideButton"
          variant="secondary"
          block
          size="lg"
          class="custom-mb-3"
          :submitting="checkNextSlide"
          isLoadingInline
          @click="nextQuestion"
        >
          <span>{{ $t("nextSlideButton") }}</span>
        </aha-antd-button>

        <div
          v-if="slide.stopSubmission"
          class="stop-submission"
        >
          {{ $t("stopSubmission") }}
        </div>

        <div v-if="errorText" class="custom-mb-3 text-center text-danger">
          {{ errorText }}
        </div>
      </form>
    </div>

    <SlideWaiting v-if="submited" />
  </div>
</template>
<script>
import { setTimeout } from 'timers'
import * as Sentry from '@sentry/vue'
import { mapState, mapGetters } from 'vuex'
import Config from '@/config'
import Util from '@/util'
import EvenBus from '@/eventBus'
import AnswersAPI from '@/api/answers'
import SlideWaiting from '@/components/SlideWaiting'
import Loading from '@/components/Loading'
import AudioControl from '@/components/AudioControl.vue'
import ProgressBarTimer from '@/components/ProgressBarTimer'
import CountDownTimer from '@/components/CountDownTimer'
import storage from '@/services/storage'

// UI
import ClickableTitleMixin from '@/mixins/ClickableTitleMixin'
import UserIsTypingMixin from '@/mixins/UserIsTypingMixin'

const WORLD_CLOUD_SUBMIT = 'Word Cloud Submit'

export default {
  components: {
    SlideWaiting,
    Loading,
    AudioControl,
    ProgressBarTimer,
    CountDownTimer,
  },
  mixins: [ClickableTitleMixin, UserIsTypingMixin],
  data() {
    return {
      items: [],
      submiting: false,
      submited: false,
      isFirstTimeSubmit: false,
      checkNextSlide: false,
      errorText: '',
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      presentation: (state) => state.presentation,
    }),
    ...mapGetters({
      slide: 'activeActivity',
    }),
    ...mapGetters('themeModule', ['isTextColourLight']),
    isLastSlide() {
      return this.presentation
        && this.slide
        && this.presentation.lastSlide === this.slide.id
    },
    isShowNextSlideButton() {
      return this.isFirstTimeSubmit
        && !this.submited
        && !this.presentation.audiencePacing
        && !this.isLastSlide
    },

  },
  watch: {
    slide: function _() {
      this.getArrInput()
      setTimeout(() => {
        if (this.$refs['slide-imgg'] && !this.$refs['slide-imgg'].complete) {
          this.isLoading = true
        }
      }, 1)
    },
  },
  mounted() {
    const index = this.slide.SlideOptions.findIndex((item) => {
      return item.audience == this.audienceId
    })
    if (!this.slide.openEndedMultipleOption && index != -1) {
      this.slide.openEndedSubmited = true
      this.submited = true
    }
    this.getArrInput()
    this.checkSubmited()
  },
  methods: {
    checkSubmited() {
      const slideId = this.slide.id
      const presentationId = this.$store.state.presentation.id
      const answeredSlideIds = storage.getValueByPresentation(presentationId, 'answeredSlideIds', [])
      const lastSlideId = this.$store.state.presentation.lastSlide
      if (answeredSlideIds.includes(slideId)) {
        if (lastSlideId === slideId &&
         !this.slide.openEndedMultipleOption) {
          this.slide.isEndSlide = true
        }
        this.$store.dispatch('updateSlide', this.slide)
      }
    },
    validateInput(item) {
      this.setUserTypingStart() // UserIsTypingMixin
      const regex = /[!@#$%^&*(),.?":{}|<>]/
      if (regex.test(item.title)) {
        item.error = this.$t('addSpecialCharacter')
      } else {
        item.error = ''

        const text = item.title
        let check = false

        this.items.forEach((element) => {
          if (element.title) {
            check = true
          }
        })

        if (!text.replace(/\s/g, '') && !check) {
          item.error = this.$t('answerWithSpace')
        } else {
          item.error = ''
        }
      }

      this.items.push()
    },
    _checkAddData() {
      let check = false
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].title.trim()) {
          if (this.items[i].title.length > 25 || this.items[i].error) {
            return false
          }
          check = true
        }
      }

      if (!check) {
        if (this.items.length) {
          this.items[0].error = this.$t('errorWordCloudWhenLeaveBlank')
          this.items.push()
        }
        return false
      }
      return true
    },

    async submit() {
      if (!this._checkAddData()) {
        return
      }
      this.submiting = true
      const arr = this.items.filter((item) => {
        if (!item.title) return false

        item.title = item.title.trim()

        return item.title
      })

      this.errorText = ''
      storage.updateValueByPresentation(this.presentation.id, 'audienceId', this.audienceId)
      // eslint-disable-next-line promise/catch-or-return
      AnswersAPI.createWordCloudAnswer({
        slideId: this.slide.id,
        items: arr,
        presentationId: this.presentation.id,
        audience: this.audienceId,
        accessCode: this.presentation.uniqueAccessCode,
        slideVersion: this.slide.version,
        createdBy: this.slide.createdBy,
      })
        .then(
          () => {
            this.items.map((item) => {
              item.title = ''
              return item
            })
            this.submiting = false
            this.isFirstTimeSubmit = true
            if (!this.slide.openEndedMultipleOption) {
              this.submited = true
              this.slide.openEndedSubmited = true
              if (this.isLastSlide) {
                this.slide.isEndSlide = true
              }
              this.$store.dispatch('updateSlide', this.slide)
            }

            Util.mixpanelTrack(
              WORLD_CLOUD_SUBMIT,
              'Audience submited',
              'Audience submited',
            )

            const presentationId = this.$store.state.presentation.id
            const answeredSlideIds = storage.getValueByPresentation(presentationId, 'answeredSlideIds', [])
            answeredSlideIds.push(this.slide.id)
            storage.setValueByPresentation(presentationId, 'answeredSlideIds', answeredSlideIds)

            // eslint-disable-next-line promise/always-return
            if (this.$store.state.presentation.audiencePacing &&
            !this.slide.openEndedMultipleOption) {
              EvenBus.$emit('skipSlide')
            } else {
              EvenBus.$emit('confirmNextSlide')
            }
          },
          (err) => {
            this.submiting = false
            if (err.body && err.body.message) {
              this.errorText = err.body.message

              Util.mixpanelTrack(
                WORLD_CLOUD_SUBMIT,
                'Audience submit fail',
                err.body.message,
              )
            } else {
              this.errorText =
                'Submission unsuccessful. Please check your connection and try again.'
              Util.mixpanelTrack(
                WORLD_CLOUD_SUBMIT,
                'Audience submit fail',
                JSON.stringify(err),
              )
            }
          },
        )
        .finally(() => {
          this.setUserTypingEnd()
        })
    },

    getArrInput() {
      const arr = []

      for (let i = 0; i < this.slide.entriesPerParticipant; i++) {
        arr.push({
          title: '',
        })
      }
      if (this.items.length != arr.length) {
        this.items = arr
      }
    },

    async nextQuestion() {
      if (this.$store.state.presentation.audiencePacing) {
        EvenBus.$emit('skipSlide')
        return
      }
      this.checkNextSlide = true
      this.slide.openEndedSubmited = true
      this.slide.openEndedMultipleOption = false

      storage.updateValueByPresentation(this.presentation.id, 'audienceId', this.audienceId)
      this.$http
        .get(
          Config.api.getPresentation +
            this.$store.state.presentation.uniqueAccessCode,
          {
            params: {
              audience: this.audienceId,
              continue: true,
            },
          },
        )
        .then((res) => {
          this.checkNextSlide = false
          res.body = Util.formatSlide(res.body)
          Util.mixpanelTrack(
            WORLD_CLOUD_SUBMIT,
            'Audience Submit',
            'Audience choose Next Slide',
          )
          // eslint-disable-next-line promise/always-return
          if (res.body.id != this.slide.id) {
            this.$store.dispatch('setSlide', res.body)
            this.isFirstTimeSubmit = false
            this.submited = false
          } else {
            this.submited = true
            if (this.isLastSlide) {
              this.slide.isEndSlide = true
              this.$store.dispatch('updateSlide', this.slide)
            }
          }
        })
        .catch(Sentry.captureException)
    },

    _imgLoaded() {
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.audio-control-slide {
  margin-bottom: 16px;
}
.button-submit {
  margin-bottom: 3px;
}

.no-data {
  margin-bottom: 16px;
}
.padding {
  padding: 0 16px;
}

.list-input {
  .text-danger {
    text-align: left;
    margin-bottom: 16px;
    font-size: 13px;
    &.white-text {
      color: #ffc3c3;
    }
  }

  .item-input {
    position: relative;
    margin-bottom: 16px;
  }
}

.label,
.submited {
  text-align: center;
  color: inherit;
  margin-bottom: 16px;
  opacity: 0.7;
}

.slide-img-wrapper {
  width: auto;
  margin: 0 auto;
  overflow: hidden;
  padding-bottom: 0.83em;
  display: flex;
  flex-direction: row;
  align-items: center;

  & ::v-deep {
    .spinner {
      width: 120px;
      margin: 0 auto;
    }
    .spinner > div {
      width: 20px;
      height: 20px;
      margin: 0 8px;
    }
  }
}
</style>
